import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { fontBold, fontExtraBold, fontNormal } from 'style/styled-components/cssGlobalVariables';
import { Breakpoints, MQ } from 'style/styled-components/cssMediaQueries';
import Button from 'components/Buttons/Button/Button';
import { ButtonInner } from 'components/Buttons/Button/Button.css';
import { ContentMarker } from 'style/styled-components/reusable.css';
import { buttonReset } from 'style/styled-components/cssButtonReset';

export const ModalNavigation = styled.div`
    position: fixed;
    height: 48px;
    width: 100%;
    top: 0;
    z-index: 1;
`;

export const MetaTitle = styled.h2`
    font-family: ${fontExtraBold};
    font-weight: normal;
    font-size: 32px;
    line-height: 40px;
    color: ${(props) => props.theme.brandedConfig.high_contrast};
    margin: 1em 0 8px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;

    ${MQ(Breakpoints.s)} {
        margin-top: 0;
        padding: 0;
    }
`;

const NavigationIcon = styled.button`
    ${buttonReset}
    cursor: pointer;

    &:hover {
        background: var(--color-dark-foreground-15);

        svg {
            color: var(--color-main-white);
        }
    }

    &:focus-visible {
        outline: var(--focus-outline);
    }
`;

export const BackButton = styled(NavigationIcon)`
    position: absolute;
    left: 16px;
    top: 6px;
    background: var(--color-dark-foreground-5);
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;

    ${MQ(Breakpoints.s)} {
        top: 16px;
        left: 26px;
    }

    ${MQ(Breakpoints.m)} {
        left: 46px;
    }

    svg {
        width: 18px;
        height: 18px;
        margin-top: 2px;
        margin-left: -2px;
    }
`;

export const MetaDescription = styled.p`
    font-family: ${fontNormal};
    font-size: 14px;
    line-height: 20px;
    color: var(--color-dark-body-70);
`;

export const MetaService = styled.p`
    font-family: ${fontNormal};
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 12px;
`;

export const StyledButton = styled(Button)`
    margin-bottom: 12px;
    font-family: ${fontBold};

    ${ButtonInner} {
        display: inline-block;
    }

    ${MQ(Breakpoints.s)} {
        float: left;
        display: inline-block;
        margin-right: 12px;
        min-width: auto;
    }
`;

export const ButtonContainer = styled.div`
    margin-top: 32px;
    flex-direction: column;
    display: flex;

    ${ButtonInner} {
        display: block;
    }

    ${MQ(Breakpoints.s)} {
        display: block;
        flex-direction: unset;

        ${ButtonInner} {
            display: inline-block;
        }
    }
`;

export const MetaContainer = styled.div`
    width: 100%;
    padding: 24px 16px 16px 16px;

    ${ContentMarker} {
        display: none;
    }

    ${MQ(Breakpoints.s)} {
        width: 480px;
        float: left;
        text-align: left;
        margin-top: 0;
        padding: 0;

        ${ContentMarker} {
            position: static;
            display: inline-block;
            padding: 4px 8px;
            margin-bottom: 12px;
            transform: unset;
        }
    }
`;

export const ImageWrapperInner = styled.div`
    height: 100%;
    display: inline-block;
    position: relative;

    ${ContentMarker} {
        position: absolute;
        bottom: 7px;
        left: 0;
    }

    img {
        height: 100%;
        width: auto;
        object-fit: contain;
        border-radius: 4px;
    }

    ${MQ(Breakpoints.s)} {
        height: auto;
        img {
            max-width: 288px;
            max-height: 270px;
        }
    }
`;

export const ImageWrapper = styled.div`
    width: 100%;
    position: relative;
    height: 56.11vw;
    overflow: hidden;
    text-align: center;

    ${MQ(Breakpoints.s)} {
        width: 288px;
        height: auto;
        float: right;
        margin-left: 32px;
    }
`;

export const OptionsContent = styled.div`
    width: 100%;

    &::after {
        clear: both;
    }

    ${MQ(Breakpoints.s)} {
        margin-top: 0;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 800px;
    }
`;
